import { render, staticRenderFns } from "./GenePanel.vue?vue&type=template&id=3a7b2f60&"
import script from "./GenePanel.vue?vue&type=script&lang=js&"
export * from "./GenePanel.vue?vue&type=script&lang=js&"
import style0 from "./GenePanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports